'use strict';

var AppDispatcher = require('../AppDispatcher'),
    ActionTypes = require('../constants/ActionTypes'),
    PaginatedStoreUtils = require('../utils/PaginatedStoreUtils'),
    InvitationStore = require('./InvitationStore'),
    UserStore = require('./UserStore'),
    ServiceTypes = require('../constants/ServiceTypes'),
    { createListStore, createListActionHandler } = PaginatedStoreUtils;

var SentInvitationStore = createListStore({
  getInvitations() {
    return this.getIds(UserStore.getMe().id).map(InvitationStore.get);
  }
});

function getList() {
  return SentInvitationStore.getList(UserStore.getMe().id);
}

var handleListAction = createListActionHandler({
  request: ActionTypes.REQUEST_INVITATIONS,
  error: ActionTypes.REQUEST_INVITATIONS_ERROR,
  success: ActionTypes.REQUEST_INVITATIONS_SUCCESS
});

AppDispatcher.register(function (payload) {
  AppDispatcher.waitFor([InvitationStore.dispatchToken]);

  var action = payload.action,
      inviteId,
      invite,
      list;

  if (!UserStore.getMe()) {
    return;
  }

  list = getList();

  handleListAction(action, list, SentInvitationStore.emitChange);

  switch (action.type) {
  case ActionTypes.SEND_INVITE_SUCCESS:
    inviteId = action.response.result;
    invite = action.response.entities.userInvitations[inviteId];
    if (!list.contains(inviteId) && invite.serviceType !== ServiceTypes.FACEBOOK) {
      list.prepend(inviteId);
    }
    SentInvitationStore.emitChange();
    break;

  case ActionTypes.UPDATE_INVITE_SUCCESS:
    inviteId = action.response.result;
    invite = action.response.entities.userInvitations[inviteId];
    if (!list.contains(inviteId)) {
      list.prepend(inviteId);
    }
    SentInvitationStore.emitChange();
    break;
  }
});

module.exports = SentInvitationStore;


/** WEBPACK FOOTER **
 ** ./stores/SentInvitationStore.js
 **/